import { classes } from '../../../lib/utils/cssUtils';
import styles from './PureVideo.module.scss';
import { useConfig } from '../../../lib/hooks/config';
import { ATTRIBUTES } from '../../../lib/constants/attributes';
import { useAttributeLabel } from '../../../lib/hooks/labels';
import { ASSET_LABEL_KEYS } from '../../../lib/constants/labelKeys';

export type PureVideoProps = {
  videoId: string;
  width?: number;
  height?: number;
  title?: string;
  containerClass?: string;
  iframeClassName?: string;
};

const PureVideo = ({ videoId, width, height, title, containerClass, iframeClassName }: PureVideoProps) => {
  const config = useConfig();
  const defaultTitle = useAttributeLabel(ATTRIBUTES.TITLE, ASSET_LABEL_KEYS.VIDEO_DEFAULT_TITLE);

  return (
    <div className={classes(styles.mainContainer, containerClass ?? '')}>
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe
        className={classes(styles.video, iframeClassName ?? '')}
        {...(title !== undefined ? { title } : defaultTitle)}
        src={`${config?.videoBaseUrl}${videoId}`}
        width={width}
        height={height}
        allowFullScreen
        allow="encrypted-media;"
        sandbox="allow-presentation allow-orientation-lock allow-scripts allow-same-origin allow-popups"
        referrerPolicy="no-referrer"
      />
    </div>
  );
};

export default PureVideo;
